import { pick } from '../util';

const actions = {
  click: 'click',
  submit: 'submit',
  change: 'change',
  hover: 'mouseenter'
};

// polyfill Object.entries because ATs use version of FF without it...
if (!Object.entries) {
  Object.entries = obj => {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i); // preallocate the Array
    while (i) {
      i -= 1;
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}

const createActions = (selectedActions, delegate) => handlerFor =>
  Object.entries(selectedActions).map(([action, domEvent]) => ({
    action,
    domEvent,
    handler: handlerFor(action),
    delegate
  }));

export const direct = createActions(pick(actions, ['hover']), false);

export const delegated = createActions(
  pick(actions, ['change', 'click', 'submit']),
  true
);

/**
 * factory function that accepts a handler factory
 * returns an object: grouped arrays of action objects ({action, domEvent, handler})
 * (grouped by direct-bound actions and delegated actions)
 *
 * the handler factory just expects the action name
 */
export default handlerFor => ({
  direct: direct(handlerFor),
  delegated: delegated(handlerFor)
});
